import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, ASSIGNMENT_GRID_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';

// import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category-model';
import { environment } from 'src/environments/environment';
import { TypesModel } from 'common/models/page-models/types/types-data-model';
import { TypesListingModel, TypesGridParams } from 'common/models/page-models/types/types-grid-model';
import { GridDataService } from '../../base-data-services/grid-data.service';

@Injectable({
  providedIn: 'root',
})
export class TypesGridDataService extends GridDataService<
  TypesListingModel,
  TypesModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.newTypeList, http, ss);
  }

  createInstance(): TypesListingModel {
    return new TypesListingModel();
  }


   


override getDeleteUrl(): string {
  return environment.apiUrl + API_URL.deleteType;

}


override getDeletePayload(data){
  let payload;
  if(data.id){
      payload={id:data.id}
  }
  else{
      payload=data;
  }
  
  return payload;
}

  override getGridParams(param): GridPostParams {
    return new TypesGridParams();
  }
  

  override getStatusUrl(): string {
    return '/typeStatus/save';
  }

  override getStatusPayload(data): any {

    let payload;
    // console.log(data)
    payload = { id: data.id, isActive: data.isActive};
    return payload;
  } 
}
